import { render, staticRenderFns } from "./Profesiograma.vue?vue&type=template&id=6c4118dd"
import script from "./Profesiograma.vue?vue&type=script&lang=js"
export * from "./Profesiograma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports